<template>
  <div>
    <music-editor-collapsed
      v-model="computedValue"
      :isEditable="isEditable"
      v-if="isCollapsed"
      @onToggleCollapse="handleToggleCollapse"
    ></music-editor-collapsed>
    <music-editor-expanded
      v-model="computedValue"
      :isEditable="isEditable"
      v-else
      @onToggleCollapse="handleToggleCollapse"
    ></music-editor-expanded>
  </div>
</template>

<script>
import MusicEditorCollapsed from './MusicEditorCollapsed';
import MusicEditorExpanded from './MusicEditorExpanded';

export default {
  name: 'MusicEditor',
  components: {
    MusicEditorCollapsed,
    MusicEditorExpanded,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    isCollapsed: {
      type: Boolean,
      default: true,
    },
    isEditable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    handleToggleCollapse() {
      this.$emit('onToggleCollapse');
    },
  },
};
</script>



// WEBPACK FOOTER //
// MusicEditor.vue?c2ca77be